import { mixed } from 'yup';

import { Locales } from '@enums/locales';

export const localeSchema = mixed<Locales>().oneOf(Object.values(Locales));
